import $ from "jquery";

export const toggleHeaderBorder = (hide) => {
    const $el = $('.site-header__container__inner');
    const isFrontpage = $('.site-header__container__inner--frontpage').length >= 1;

    if (hide) {
        $el.addClass('site-header__container__inner--borderless');
    } else {
        if (!isFrontpage) {
            $el.removeClass('site-header__container__inner--borderless');
        }
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/Helpers/headerBorderToggler.js